import myAPI from './resources'
import config, { enterpriseservice } from '../config'

export default {
  getStates: async function () {
    return await myAPI.get(config.enterpriseservice + '/state');
  },
  getMakes: function () {
    return myAPI.get(config.inventory_root + '/make')
      .then(function (response) {
        return response
      })
      .catch(err => {
        throw new Error(err);
      })
  },
  getModels: function (make) {
    return myAPI.get(config.inventory_root + '/model/?makeID=' + make)
      .then(function (response) {
        return response
      })
      .catch(err => {
        throw new Error(err);
      })
  },
  getFuelTypes: function (make) {
    return myAPI.get(config.inventory_root + '/tblFuelType')
      .then(function (response) {
        return response
      })
      .catch(err => {
        throw new Error(err);
      })
  },
  getEnhancements: function () {
    return myAPI.get(config.carbuyservice + '/enhancements')
      .then(function (response) {
        return response
      })
      .catch(err => {
        throw new Error(err);
      })
  },/*
  getQuoteStatus: function () {
    return myAPI.get(config.api_root + config.api_root_path_admin + '/status')
      .then(function (response) {
        return response
      })
      .catch(err => {
        throw new Error(err);
      })
  } */
  zbValidateEmail: function (emailAddress) {
    if (emailAddress && (emailAddress.toLocaleLowerCase().endsWith("pullapart.biz") || emailAddress.toLocaleLowerCase().endsWith("pullapart.com"))) {
      return {
        "data": {
          "address": emailAddress,
          "status": "valid",
          "sub_status": ""
        }
      };
    }
    return myAPI.get("https://api.zerobounce.net/v2/validate?api_key=" + config.zerobounce_api_key + "&email=" + emailAddress + "&ip_address=")
      .catch((err) => {
        console.log(err);
        return err;
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/misc.js